module.exports = __webpack_public_path__ + "assets/4987c53ea4412cee04ca1695d3d8fda6.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/open.mp3
 ** module id = 231
 ** module chunks = 0
 **/